<script lang="ts" setup>
defineProps<{
    qrCode: string;
}>();

const emit = defineEmits<{
    confirm: [];
}>();
</script>

<template>
    <div class="preview-chip-container">
        <button type="button" class="preview-chip" @click="emit('confirm')">
            <v-icon size="16">mdi-clipboard-text</v-icon>
            <span class="preview-chip-text">{{ qrCode }}</span>
        </button>
    </div>
</template>

<style scoped>
.preview-chip-container {
    position: absolute;
    bottom: 24px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
}

.preview-chip {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 20px;
    background-color: #fef08a;
    border: none;
    border-radius: 24px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

    &:hover:not(:disabled) {
        background-color: #fde047;
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}

.preview-chip-text {
    color: #000;
}
</style>
